import "core-js/modules/es.array.filter";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.define-property";
import { __decorate, __extends } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';

var SubSelect = function (_super) {
  __extends(SubSelect, _super);

  function SubSelect() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Object.defineProperty(SubSelect.prototype, "filterComplianceOfficerList", {
    get: function get() {
      var _this = this;

      return this.complianceOfficerList.filter(function (item) {
        return item.country_code === _this.$enum.common.CountryEnum.GB;
      });
    },
    enumerable: false,
    configurable: true
  });

  __decorate([Prop({
    type: Object
  })], SubSelect.prototype, "data", void 0);

  __decorate([Prop({
    type: Array,
    "default": []
  })], SubSelect.prototype, "complianceOfficerList", void 0);

  __decorate([Prop({
    type: Number
  })], SubSelect.prototype, "index", void 0);

  __decorate([Prop({
    type: Object
  })], SubSelect.prototype, "formDataRule", void 0);

  SubSelect = __decorate([Component], SubSelect);
  return SubSelect;
}(Vue);

export default SubSelect;